export const listCurrentLanguage = {
    ja: "JP",
    ko: "KR",
    en: "US",
    vi: "VN",
    zh: "CN"
};